import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseComponent, DataTableRequest, LanguageService, SearchData, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { AuthenticationService, CountryModel, CountryService } from 'src/app/services/api-services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CountryCheckboxComponent } from '../../../../../../../Vestra.shared/src/lib/components/custom-datatable-components/country-checkbox.component';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ADTSettings } from 'angular-datatables/src/models/settings';

@Component({
    selector: 'app-country-list',
    templateUrl: './country-list.component.html',
    styleUrls: ['./country-list.component.scss'],
})
export class CountryListComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('countryCheckboxRef') countryCheckboxRef: TemplateRef<CountryCheckboxComponent>;

    constructor(private translatedToastrService: TranslatedToastrService, protected override modalService: BsModalService, private countryService: CountryService, protected override validationHandlerService: ValidationHandlerService, private translateService: TranslateService, protected override spinnerService: NgxSpinnerService, protected override languageService: LanguageService, private authenticationService: AuthenticationService) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }
    get canDisable(): boolean {
        return this.authenticationService.canDisable();
    }

    public override getDtOptions() {
        this.languageUrl = this.languageService.getTranslationUrl();
        const translateService = this.translateService;

        const res: ADTSettings = {
            serverSide: true,
            processing: false,
            pageLength: 20,
            lengthChange: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                },
            },
            searching: false,
            destroy: true,
            language: {
                url: this.languageUrl,
            },
            ajax: (dataTablesParams: any, callback: any) => {
                const searchData: SearchData = {
                    value: this.searchValue,
                };

                for (let order of dataTablesParams.order) {
                    order.name = dataTablesParams.columns[order.column]?.data;
                }

                const model: DataTableRequest = {
                    draw: dataTablesParams.draw,
                    start: dataTablesParams.start,
                    length: dataTablesParams.length,
                    order: dataTablesParams.order,
                    search: searchData,
                    columns: this.transformToColumnData(this.dtOptions.columns),
                };

                this.datatableRequest = model;

                this.handleSpinner(firstValueFrom(this.countryService.getCountryListDataSource(model)))
                    .then(res => {
                        res.data.sort((a: any, b: any) => {
                            if (a.key === 'country.united_states') return -1;
                            if (b.key === 'country.united_states') return 1;
                            return 0;
                        });
                        callback(this.getTableData(res));
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                        callback(this.getEmptyTableData());
                    });
            },
            columns: [
                {
                    data: 'key',
                    title: 'country.translated_key',
                    searchable: false,
                    orderable: true,
                    render: function (data) {
                        return translateService.instant(data);
                    },
                },
                ...(this.canDisable
                    ? [
                          {
                              data: 'isEnabled',
                              title: 'country.is_enabled',
                              searchable: false,
                              orderable: true,
                              defaultContent: '',
                              ngTemplateRef: {
                                  ref: this.countryCheckboxRef,
                                  context: {
                                      captureEvents: this.updateCountryStatus.bind(this),
                                  },
                              },
                              responsivePriority: 2,
                          },
                      ]
                    : []),
                {
                    data: '',
                    orderable: false,
                    responsivePriority: 1,
                    render: function (data) {
                        return '';
                    },
                },
            ],
            columnDefs: [
                {
                    targets: '_all',
                    visible: true,
                },
                {
                    className: 'details-icon dtr-control',
                    orderable: false,
                    target: -1,
                },
            ],
        };

        return res;
    }
    public ngOnInit(): void {
        this.dataTableOnInit();
    }

    public ngAfterViewInit() {
        this.dataTableAfterViewInit();
    }

    public ngOnDestroy() {
        this.dataTableOnDestroy();
    }

    public updateCountryStatus(event: { isChecked: boolean; data: any }) {
        const countryData: CountryModel = {
            id: event.data.id,
            key: event.data.key,
            isEnabled: event.isChecked,
        };
        return this.handleSpinner(
            firstValueFrom(this.countryService.updateCountryStatus(countryData))
                .then(res => {
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err);
                })
        );
    }

    public getCustomButtonTitle(row: any): string {
        return row.isEnabled ? 'common.enabled' : 'common.disabled';
    }
}
